import styled from 'styled-components';

export const ContainerInfoBox = styled.div<{ type: 'info' | 'warning' | 'danger' }>`
	background-color: ${({ theme, type }) =>
		type === 'info'
			? theme.palette.primary['100']
			: type === 'warning'
			? theme.palette.risk.moderate[100]
			: theme.colors.danger};
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_md};
	padding: 15px 16px;
	display: flex;
	align-items: center;
	color: ${({ theme, type }) => (type === 'danger' ? theme.palette.secondary.white : theme.palette.secondary['400'])};

	svg {
		color: ${({ theme, type }) =>
			type === 'info'
				? theme.palette.primary.default
				: type === 'danger'
				? theme.palette.secondary.white
				: theme.palette.risk.moderate.default};
		margin-right: 10px;
	}
`;
